import type { OrganizationType } from "../constants/organization";

export enum OrganizationFastPlanOptions {
  DISABLED = "disabled",
  FAST = "fast",
  FAST_PLUS = "fast+",
  FAST_LEGACY = "fast_legacy",
}

export interface OrganizationParamsResponse {
  invoice_url: string;
  organization_creation_date: Date;
  organization_uuid: string;
  organization_options: OrganizationOptions;
  organization_plan: OrganizationPlan;
  organization_plan_options: OrganizationPlanOption[];
  organization_renewal_date: Date;
  organization_label: string;
  organization_type: OrganizationType;
  notif_encoding_finished_zapier: boolean;
}

export interface OrganizationOptions {
  allow_bulk: boolean;
  allow_display: boolean;
  allow_fast: boolean;
  allow_live_okast: boolean;
  allow_multiple_playlists: boolean;
  allow_push_notification: boolean;
  allow_replay: boolean;
  allow_sponso: boolean;
  allow_zapier: boolean;
  encoding_plan: string;
  live_encoding_plan: string;
  sfp_limit: number;
  fast_plan: OrganizationFastPlanOptions;
}

export interface OrganizationPlan {
  included_encoding_seconds: number;
  label: string;
  max_active_users: number;
}

export interface OrganizationPlanOption {
  label: string;
  type: string;
  uuid: string;
}
